/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdjacentNewsDto } from '../../models/adjacent-news-dto';

export interface NewsControllerFindAdjacentV1$Params {

/**
 * 보도자료 ID
 */
  id: string;
}

export function newsControllerFindAdjacentV1(http: HttpClient, rootUrl: string, params: NewsControllerFindAdjacentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjacentNewsDto>> {
  const rb = new RequestBuilder(rootUrl, newsControllerFindAdjacentV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdjacentNewsDto>;
    })
  );
}

newsControllerFindAdjacentV1.PATH = '/api/v1/news/{id}/adjacent';
